import ApisService from './index'
import { IMenu, IUpdateFunctionApiPayload } from '../interfaces/menuInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createMenu(data: IMenu) {
  try {
    const bodyData = {...data, parentId: data.parentId == "" ? null : data.parentId}
    return ApisService.post('/menu/create-menu', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateMenu(data: IMenu) {
  try {
    const bodyData = {...data, parentId: data.parentId == "" ? null : data.parentId}
    return ApisService.put('/menu/' + data.id + '/update-menu', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateChucNangApi(data: IMenu) {
  try {
    const bodyData = {...data, parentId: data.parentId == "" ? null : data.parentId}
    return ApisService.put('/menu/' + data.id + '/update-menu', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailMenu(id: string) {
  try {
    return ApisService.get('/menu/' + id + '/get-chitiet-menu')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListMenu(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/menu/filter-menu', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListOptionMenu(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/menu/filter-menu', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMenu(id: string) {
  try {
    return ApisService.delete('/menu/' + id + '/delete-menu')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultiMenu(idArr: Array<string>) {
  try {
    return ApisService.delete('/menu/bulk-delete-menu', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateFunctionApi(data: IUpdateFunctionApiPayload) {
  try {
    return ApisService.put('/menu/update-chucnang-api', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteApi(id: number) {
  try {
    return ApisService.delete('/api/' + id + '/delete-api')
  } catch (err) {
    handleError(err)
    throw err
  }
}
